import {fetchDeliveryStatuses} from "../React/api/delivery-statuses";
import {deliveryStatusClassName, deliveryStatusIconClassName} from "./deliveryStatusMarkup";

const render = (cell, status) => {
  const span = document.createElement('span');
  span.className = deliveryStatusClassName(status?.kind);

  const icon = deliveryStatusIconClassName(status?.kind);
  if (icon) {
    const i = document.createElement('i');
    i.className = icon;
    span.append(i, ' ');
  }

  span.append(status?.label ?? '-');
  cell.replaceChildren(span);
};

export const loadDeliveryStatuses = async () => {
  const cells = Array.from(document.querySelectorAll('[data-delivery-status]:not([data-delivery-status-loaded])'));
  if (!cells.length) {
    return;
  }

  cells.forEach((cell) => cell.setAttribute('data-delivery-status-loaded', ''));

  const items = cells.map((cell) => ({
    productCode: cell.dataset.productCode,
    unitCode: cell.dataset.unitCode,
    quantity: cell.dataset.quantity ? Number(cell.dataset.quantity) : null,
  }));

  const statuses = await fetchDeliveryStatuses(items);

  cells.forEach((cell, index) => {
    const status = statuses[index];
    const matches = status
      && status.productCode === items[index].productCode
      && status.unitCode === items[index].unitCode;
    render(cell, matches ? status : null);
  });
};
